import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type RemoveEntityModalProps = {
  open: boolean;
  entityName: string;
  isRemoving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const RemoveEntityModal = ({
  open,
  entityName,
  isRemoving,
  onCancel,
  onConfirm,
}: RemoveEntityModalProps) => (
  <Modal.Root open={open} onOpenChange={(next) => !next && onCancel()}>
    <Modal.Content useCustomOverlay size="small">
      <StatusModal type="danger" title="Remove entity">
        <p className="t-mt-3 t-text-body t-text-text-60">
          Are you sure you want to remove{" "}
          <span className="t-font-medium t-text-text-100">{entityName}</span>?
          This action cannot be undone.
        </p>
      </StatusModal>
      <Modal.Footer className="t-flex t-justify-end t-gap-3">
        <Button customType="secondary" type="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          customType="danger"
          type="button"
          onClick={onConfirm}
          isLoading={isRemoving}
          disabled={isRemoving}
        >
          Remove
        </Button>
      </Modal.Footer>
    </Modal.Content>
  </Modal.Root>
);
